export const homeImages = [
  {
    imgNum: 1,
    imgSrc: "SeasonSuites/Legacy/legacy_1.jpg",
    title: "SUITES",
    subTitle: "",
    desc: "The suites at Globe Life Field offer you an exclusive private experience to entertain and take in Rangers baseball. Discover the suite that will make this season special for you.",
    caption: "LEGACY SUITE",
    links: [
      {
        linkNum: 1,
        linkTitle: "Suite Rentals",
        linkDesc: "Want to rent a suite for a game?",
        linkURL: "/suite-rentals",
      },
      {
        linkNum: 2,
        linkTitle: "Season Suites",
        linkDesc: "Want to own a suite for the season?",
        linkURL: "/season-suites",
      },
    ],
  },
  {
    imgNum: 2,
    imgSrc: "SeasonSuites/FieldSuites/field_1.jpg",
    title: "",
    subTitle: "",
    desc: "",
    caption: "FIELD SUITE",
    links: [],
  },
  {
    imgNum: 3,
    imgSrc: "SeasonSuites/FoundersSuites/founders_1.jpg",
    title: "",
    subTitle: "",
    desc: "",
    caption: "FOUNDERS SUITE",
    links: [],
  },
  {
    imgNum: 4,
    imgSrc: "SeasonSuites/ClassicSuites/classic_season20_1.jpg",
    title: "",
    subTitle: "",
    desc: "",
    caption: "CLASSIC SUITE",
    links: [],
  },
  {
    imgNum: 6,
    imgSrc: "SuiteRentals/ClassicSuites/40person/classic_rental40_1.jpg",
    title: "",
    subTitle: "",
    desc: "",
    caption: "40-PERSON CLASSIC SUITE",
    links: [],
  },
  {
    imgNum: 7,
    imgSrc: "SuiteRentals/HOF/hall-of-fame_1.jpg",
    title: "",
    subTitle: "",
    desc: "",
    caption: "HALL OF FAME SUITE",
    links: [],
  },
  {
    imgNum: 8,
    imgSrc: "SuiteRentals/PartySuites/Lower/party_lower_1.jpg",
    title: "",
    subTitle: "",
    desc: "",
    caption: "PARTY SUITE",
    links: [],
  },
  {
    imgNum: 9,
    imgSrc: "SuiteRentals/PartySuites/Upper/party_upper_1.jpg",
    title: "",
    subTitle: "",
    desc: "",
    caption: "PARTY SUITE",
    links: [],
  },
];
